import { render, staticRenderFns } from "./ListPromoCodes.vue?vue&type=template&id=000dec48&scoped=true&"
import script from "./ListPromoCodes.vue?vue&type=script&lang=js&"
export * from "./ListPromoCodes.vue?vue&type=script&lang=js&"
import style0 from "./ListPromoCodes.vue?vue&type=style&index=0&id=000dec48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000dec48",
  null
  
)

export default component.exports